exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,800,900&display=swap);", ""]);

// module
exports.push([module.id, ".SLO-Module__grid___2XOSs{display:grid;grid-gap:5px;grid-template-columns:2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;font-family:montserrat}.SLO-Module__grid___2XOSs .SLO-Module__grid-item___2y_gb{color:#fff;padding:7px;background-color:hsla(0,0%,100%,.1);text-align:center;cursor:pointer;opacity:.4}.SLO-Module__grid___2XOSs .SLO-Module__grid-item___2y_gb.SLO-Module__active___2Q06n{opacity:1}.SLO-Module__grid___2XOSs .SLO-Module__grid-heading___3XMIG{font-weight:550;color:#fff;padding:7px 7px 7px 10px;background-color:hsla(0,0%,100%,.1);min-width:125px}", ""]);

// exports
exports.locals = {
	"grid": "SLO-Module__grid___2XOSs",
	"grid-item": "SLO-Module__grid-item___2y_gb",
	"active": "SLO-Module__active___2Q06n",
	"grid-heading": "SLO-Module__grid-heading___3XMIG"
};